import * as React from 'react';

import UserExplorerFilter from './UserExplorerFilter';

import ExplorerCurrentCategory from '../../interfaces/ExplorerCurrentCategory';
import Event from '../../interfaces/Event';

import './style.scss';

interface Props {
  userExplorer: Event[];
  filteredCategory: ExplorerCurrentCategory;
}

function UserExplorerTable (props: Props) {
  return (
    <div className='user-explorer-table'>
      <UserExplorerFilter
        events={props.userExplorer}
        filteredCategory={props.filteredCategory}
      />
    </div>
  );
  
}

export default React.memo(UserExplorerTable);
